<template>
  <div>
    <v-breadcrumbs :items="items"></v-breadcrumbs>
    <v-card class="mb-5">
      <v-card-title>
        <v-container>
          <v-row>
            <v-col cols="12" md="2" class="mr-5 mb-1">
              Invoice Void
            </v-col>
            <v-col cols="12" md="3" class="me-5">
              <v-menu
                  v-model="menu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                      v-model="date"
                      label="Select Date"
                      prepend-icon="mdi-calendar"
                      readonly
                      v-bind="attrs"
                      v-on="on"
                      outlined
                      hide-details
                      dense
                  ></v-text-field>
                </template>
                <v-date-picker
                    v-model="date"
                    @input="menu2 = false"
                    :max="nowDate"
                    type="month"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col cols="12" md="2" class="me-5">
              <v-text-field
                  v-model="search"
                  append-icon="mdi-magnify"
                  label="Search"
                  single-line
                  hide-details
                  outlined
                  dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="2" class="me-5">
              <v-row align="center" justify="center">
                <v-col cols="auto"  v-if="user_id == 50 || user_id == 61 || user_id == 55 " >
                  <v-tooltip top>
                    <template v-slot:activator="{ on }">
                      <v-btn
                          depressed
                          v-on="on"
                          class="ms-2"
                          color="primary"
                          v-on:click="void_invoice_dialog_open"
                      >
                        <v-icon>mdi-plus</v-icon>
                      </v-btn>
                    </template>
                    <span>Void</span>
                  </v-tooltip>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
        </v-container>
      </v-card-title>
    </v-card>
    <v-card>
      <v-data-table
          :headers="headers"
          :items="desserts"
          class="elevation-1"
          :search="search"
      >
        <template v-slot:item.void_description="{ item }">
          <span v-html="item.void_description"></span>
        </template>
        <template v-slot:no-data>
          <v-btn color="primary" @click="invoiceVoidLists">Reset</v-btn>
        </template>
      </v-data-table>
    </v-card>

    <template>
      <div class="text-center">
        <v-dialog v-model="void_invoice_dialog" width="500">
          <v-card>
            <v-card-title><span class="text-h5 grey lighten-2">Void Invoice</span>
              <p>(Only for Consultation and Investigation)</p>
            </v-card-title>
            <template>
              <v-form>
                <v-container>
                  <v-row>
                    <v-col cols="12">
                      <v-text-field
                          v-model="voidDataSubmit.invoice_id"
                          outlined
                          dense
                          label="Invoice ID"
                          required
                          v-on:change="getPatientIdUsingInvoiceID"
                      ></v-text-field>
                      <div v-if="patient_details" class="mb-2">
                        <v-btn small color="primary">{{ patient_details }}</v-btn>
                      </div>
                      <v-select
                          v-model="voidDataSubmit.invoice_type"
                          :items="['consultation', 'investigation']"
                          required
                          label="Select Invoice Type"
                          outlined
                          dense
                          chips
                          hide-details
                          class="mb-3"
                      ></v-select>
                      <v-textarea
                          v-model="voidDataSubmit.void_description"
                          label="Why?"
                          outlined
                          dense
                      ></v-textarea>
                      <v-autocomplete
                          v-model="voidDataSubmit.request_user_id"
                          :items="users"
                          item-text="full_name"
                          item-value="id"
                          required
                          label="Request User name"
                          outlined
                          dense
                          chips
                          hide-details
                      ></v-autocomplete>
                    </v-col>
                  </v-row>
                </v-container>
              </v-form>
            </template>
            <v-divider></v-divider>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text @click="void_invoice_dialog = false"> Cancel</v-btn>
              <v-btn color="primary" @click="void_invoice_submit" text> Submit</v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </div>
    </template>
  </div>
</template>
<style scoped>
.layout {
  display: inline-block;
  width: 100%;
}
</style>
<script>
import atshq from "../../../js/setup";
import moment from "moment/moment";


export default {
  data() {
    return {
      void_invoice_dialog: false,
      patient_details: '',
      voidDataSubmit: {
        invoice_id: '',
        invoice_type: '',
        void_description: '',
        request_user_id: '',
        login_user_id: localStorage.getItem("userId"),
      },
      search: "",
      sortBy: "operation.name",
      sortDesc: false,
      date: moment().format('YYYY-MM'),
      nowDate: moment().format('YYYY-MM'),
      menu2: false,
      loading: true,
      headers: [
        {text: "Invoice ID", align: "start", value: "invoice_id",},
        {text: "Description", value: "void_description"},
        {text: "Create at", value: "create_date"},
        {text: "Request User", value: "request_user.full_name"},
        {text: "User", value: "user.full_name"},
      ],
      desserts: [],
      users: [],
      items: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
        },
        {
          text: "Invoice Void",
          disabled: true,
          href: "/",
        },
      ],
      returnUrl: atshq.defaults.headers.common.app_URL,
      user_id: localStorage.getItem("userId"),

    };
  },
  // Fetches posts when the component is created.
  created() {
    this.invoiceVoidLists();
    this.getUsers();
  },
  mounted() {

  },
  watch: {
    date() {
      this.invoiceVoidLists();
    }
  },
  methods: {
    invoiceVoidLists() {
      atshq
          .get("invoices/void?date=" + this.date)
          .then((response) => {
            // JSON responses are automatically parsed.
            this.desserts = response.data.data;
            this.loading = false;
          })
          .catch((e) => {
            this.errors.push(e);
          });

    },
    getUsers() {
      atshq
          .get("users/user")
          .then((response) => {
            this.users = response.data.data;
            this.loadingStatus = false;
          })
          .catch((e) => {
            // this.errors.push(e);
            console.log(e);
          });
    },
    void_invoice_dialog_open() {
      this.voidDataSubmit.invoice_id = ''
      this.voidDataSubmit.invoice_type = ''
      this.voidDataSubmit.void_description = ''
      this.voidDataSubmit.request_user_id = ''
      this.void_invoice_dialog = true
    },
    getPatientIdUsingInvoiceID()
    {
      if (this.voidDataSubmit.invoice_id){
        atshq
            .get("invoices/get-patient-id-using-invoice-id/"+this.voidDataSubmit.invoice_id)
            .then((response) => {
              this.patient_details = response.data.patient_details
            }).catch((e) => {
          this.$noty.error(e.response.data.message)
        })
      }
    },
    void_invoice_submit() {
      this.$swal({
        title: 'Are you sure?',
        text: "You won't be able to revert this!",
        type: 'success',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, submit it!'
      }).then((result) => {
        if (result.value) {
          atshq
              .post("invoices/void-invoice", {'submitData': this.voidDataSubmit})
              .then((response) => {
                this.$noty.success(response.data.message)
                this.voidDataSubmit.invoice_id = ''
                this.voidDataSubmit.invoice_type = ''
                this.voidDataSubmit.void_description = ''
                this.voidDataSubmit.request_user_id = ''
                this.void_invoice_dialog = false
                this.invoiceVoidLists();
                this.patient_details = '';
              }).catch((e) => {
                this.$noty.error(e.response.data.message)
              })
        }
      });
    },
  },
};
</script>
